module.exports = __webpack_public_path__ + "img/162.37cb7644.jpg";